export default {
  gradeFunctionalCracked: {
    id: 'bo_sellers-buyback-opportunities-filters-grade-functional-cracked',
    defaultMessage: 'Functional Cracked',
  },
  gradeFunctionalUsed: {
    id: 'bo_sellers-buyback-opportunities-filters-grade-functional-used',
    defaultMessage: 'Functional Used',
  },
  gradeFunctionalGood: {
    id: 'bo_sellers-buyback-opportunities-filters-grade-functional-good',
    defaultMessage: 'Functional Good',
  },
  gradeFunctionalFlawless: {
    id: 'bo_sellers-buyback-opportunities-filters-grade-functional-flawless',
    defaultMessage: 'Functional Flawless',
  },
  gradeNotFunctionalCracked: {
    id: 'bo_sellers-buyback-opportunities-filters-grade-not-functional-cracked',
    defaultMessage: 'Not Functional Cracked',
  },
  gradeNotFunctionalUsed: {
    id: 'bo_sellers-buyback-opportunities-filters-grade-not-functional-used',
    defaultMessage: 'Not Functional Used',
  },
  categorySmartphone: {
    id: 'bo_sellers-buyback-opportunities-filters-category-smartphone',
    defaultMessage: 'Smartphones',
  },
  categoryTablet: {
    id: 'bo_sellers-buyback-opportunities-filters-category-tablet',
    defaultMessage: 'Tablets',
  },
  categoryAudio: {
    id: 'bo_sellers-buyback-opportunities-filters-category-audio',
    defaultMessage: 'Audio',
  },
  categoryMacbook: {
    id: 'bo_sellers-buyback-opportunities-filters-category-macbook',
    defaultMessage: 'Macbooks',
  },
  categoryGamingConsole: {
    id: 'bo_sellers-buyback-opportunities-filters-category-gaming-console',
    defaultMessage: 'Gaming Consoles',
  },
  pageSize: {
    id: 'bo_sellers-buyback-opportunities-filters-page-size',
    defaultMessage: '{pageSize} listings',
  },
  errorGettingMarkets: {
    id: 'bo_sellers-buyback-opportunities-filters-error-getting-markets',
    defaultMessage: 'Error getting markets',
  },
  competitionLevelHigh: {
    id: 'bo_sellers-buyback-opportunities-filters-competition-level-high',
    defaultMessage: 'High',
  },
  competitionLevelMedium: {
    id: 'bo_sellers-buyback-opportunities-filters-competition-level-medium',
    defaultMessage: 'Medium',
  },
  competitionLevelLow: {
    id: 'bo_sellers-buyback-opportunities-filters-competition-level-low',
    defaultMessage: 'Low',
  },
  competitionLevelVeryLow: {
    id: 'bo_sellers-buyback-opportunities-filters-competition-level-very-low',
    defaultMessage: 'Very Low',
  },
}
